import { FhirResource } from '@models/fhir-resource';
import type { LocationValues } from '@models/location';

import type { LocationModelInput } from 'generated/types';

export function getLocationTemplate(
  values: LocationValues
): LocationModelInput {
  const input: LocationModelInput = {
    name: values.name,
    ...((values.city || values.country || values.region) && {
      address: {
        city: values.city,
        country: values.country,
        state: values.region,
      },
    }),
  };
  return FhirResource.stripNulls(input) as LocationModelInput;
}
